// extracted by mini-css-extract-plugin
module.exports = {"header":"TIZE3","list":"_2JH-w","badges":"_3tcLf","badge":"_11B6l"};